<template>
    <b-card no-body>
        <b-modal
            id="create-or-update"
            size="lg"
            :title="isReadOnly ? 'Detay' : editing ? 'Güncelle' : 'Oluştur'"
            no-close-on-esc
            no-close-on-backdrop
        >
            <fuel-storage-order-create-or-update
                v-model="order"
                :is-read-only="isReadOnly"
                :is-sub-order="order._isSubOrder || false"
                :sub-order-index="order._subOrderIndex === undefined ? null : order._subOrderIndex"
                v-on:validation-changed="isFormInvalid = $event"
                @sub-order-completed="handleSubOrderCompleted"
            />
            <template #modal-footer>
                <div>
                    <v-executer
                        v-if="!isReadOnly"
                        :loading="loading"
                        :editing="editing"
                        :action="createOrUpdate"
                        :disabled="!order.FuelTypeId || isFormInvalid"
                    />
                </div>
            </template>
        </b-modal>

        <b-modal
            id="create-or-update-new"
            size="lg"
            :title="isReadOnly ? 'Detay' : editing ? 'Güncelle' : 'Oluştur'"
            no-close-on-esc
            no-close-on-backdrop
        >
            <fuel-storage-order-create-or-update-new
                v-model="order"
                :is-read-only="isReadOnly"
                :is-sub-order="order._isSubOrder || false"
                :sub-order-index="order._subOrderIndex === undefined ? null : order._subOrderIndex"
                v-on:validation-changed="isFormInvalid = $event"
                @sub-order-completed="handleSubOrderCompleted"
            />
            <template #modal-footer>
                <div>
                    <v-executer v-if="!isReadOnly" :loading="loading" :editing="editing" :action="createOrUpdate" :disabled="isFormInvalid" />
                </div>
            </template>
        </b-modal>

        <b-modal id="view-order-detail" size="xl" title="İşlenmiş Evrak Detayları" ok-only ok-title="Kapat">
            <fuel-order-detail-view v-if="selectedOrderId" :fuel-order-id="selectedOrderId" />
            <template #modal-footer>
                <div></div>
            </template>
        </b-modal>

        <fuel-storage-main-order-modal
            v-if="false"
            :value="mainOrderModalConfig.data"
            :is-edit="mainOrderModalConfig.isEdit"
            :is-read-only="mainOrderModalConfig.isReadOnly"
        />

        <fuel-storage-main-order-modal-new
            :value="mainOrderModalConfig.data"
            :is-edit="mainOrderModalConfig.isEdit"
            :is-read-only="mainOrderModalConfig.isReadOnly"
            @save="saveMainOrder"
            @edit-sub-order="openSubOrderEdit"
            @close="closeMainOrderModal"
            @update:totalQuantity="mainOrderModalConfig.data.TotalQuantity = $event"
            @update:shipmentCount="mainOrderModalConfig.data.ShipmentCount = $event"
            @update:subOrders="mainOrderModalConfig.data.SubOrders = $event"
            @update:subOrderField="updateSubOrderField"
        />

        <v-table
            ref="table"
            :items-provider="provider"
            pagination="server"
            :fields="fields"
            :buttons="buttons"
            :add-callback="createNew"
            search
            button-alignment="text-left"
        >
            <template #filters>
                <div class="row">
                    <div class="col-md-4">
                        <label>Başlangıç Tarihi</label>
                        <v-date-picker v-model="filter.startDate" v-on:input="$refs.table.refresh()" />
                    </div>

                    <div class="col-md-4">
                        <label>Bitiş Tarihi</label>
                        <v-date-picker v-model="filter.endDate" v-on:input="$refs.table.refresh()" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Yakıt Tipi</label>
                        <v-select
                            v-model="filter.fuelTypeId"
                            :options="fuelTypes"
                            v-on:input="$refs.table.refresh()"
                            placeholder="Tümü"
                            label="VisibleName"
                            :reduce="(option) => option.Id"
                        />
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-md-4">
                        <label class="form-label">Araç Plakası</label>
                        <v-select
                            v-model="filter.vehiclePlateId"
                            :options="vehiclePlateOptions"
                            v-on:input="$refs.table.refresh()"
                            placeholder="Tümü"
                            label="PlateValue"
                            :reduce="(option) => option.Id"
                        />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Tedarikçi</label>
                        <v-select
                            v-model="filter.supplierId"
                            :options="supplierOptions"
                            v-on:input="$refs.table.refresh()"
                            placeholder="Tümü"
                            label="Name"
                            :reduce="(option) => option.Id"
                        />
                    </div>
                    <div class="col-md-2">
                        <label class="form-label">Şube</label>
                        <v-select
                            v-model="filter.branchId"
                            :options="branchOptions"
                            v-on:input="$refs.table.refresh()"
                            placeholder="Tümü"
                            label="Name"
                            :reduce="(option) => option.Id"
                        />
                    </div>
                    <div class="col-md-2 d-flex align-items-end">
                        <button class="btn btn-outline-secondary w-100 text-nowrap" @click="clearFilters">Temizle</button>
                    </div>
                </div>
            </template>
            <template #additional-actions>
                <div class="d-flex justify-content-end w-100">
                    <button
                        v-b-tooltip.hover.bottom
                        title="Dışa Aktar"
                        class="btn btn-sm btn-icon rounded-circle btn-outline-success p-25"
                        v-on:click="downloadExcel"
                        :disabled="loading"
                    >
                        <feather-icon icon="ArrowDownIcon" size="12" />
                    </button>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard, BButton, VBTooltip } from "bootstrap-vue";
import FuelStorageOrderCreateOrUpdate from "./components/FuelStorageOrderCreateOrUpdate.vue";
import SystemDataApi from "@/api/system-data";
import FuelOrderDetailView from "../fuel-management/components/FuelOrderDetailView.vue";
import FuelStorageMainOrderModal from "./components/FuelStorageMainOrderModal.vue";
import FuelStorageMainOrderModalNew from "./components/FuelStorageMainOrderModalNew.vue";
import FuelStorageOrderCreateOrUpdateNew from "./components/FuelStorageOrderCreateOrUpdateNew.vue";
import CompanyApi from "@/api/company";
import VehicleOperationsApi from "@/api/vehicle-operations";
import FirmOperationsApi from "@/api/firm-operations";
import Additional from "@/utilities/additional";
import FuelStorageApi from "@/api/fuel-storage";

export default {
    components: {
        BCard,
        BButton,
        FuelStorageOrderCreateOrUpdate,
        FuelStorageOrderCreateOrUpdateNew,
        FuelOrderDetailView,
        FuelStorageMainOrderModal,
        FuelStorageMainOrderModalNew,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    data() {
        return {
            fields: [
                { name: "Ana Sipariş No", key: "MainOrderNumber", thClass: "text-nowrap", tdClass: "w-9 text-nowrap" },
                { name: "Sipariş No", key: "OrderNumber", thClass: "text-nowrap", tdClass: "w-7 text-nowrap" },
                {
                    name: "Sipariş Durumu",
                    key: "OrderStatusName",
                    thClass: "text-nowrap",
                    tdClass: "w-9 text-nowrap",
                    component: true,
                    componentOptions: { name: "fuel-storage/OrderStatusBadge" },
                },
                { name: "Sipariş Tarihi", key: "OrderDateValue", thClass: "text-nowrap", tdClass: "w-7 text-nowrap" },
                {
                    name: "Yakıt Tipi",
                    key: "FuelTypeName",
                    thClass: "text-nowrap",
                    tdClass: "w-7 text-nowrap",
                    component: true,
                    componentOptions: { name: "fuel-storage/FuelTypeBadge" },
                },
                { name: "Sipariş Miktarı [lt]", key: "OrderQuantityStr", thClass: "text-nowrap", tdClass: "w-7 text-nowrap text-right" },
                { name: "Kalan Miktar [lt]", key: "RemainingOrderQuantityStr", thClass: "text-nowrap", tdClass: "w-7 text-nowrap text-right" },
                { name: "Birim Fiyat [lt/TL]", key: "UnitPrice", thClass: "text-nowrap", tdClass: "w-4 text-nowrap  text-right" },
                { name: "Taşıma Maliyeti [TL]", key: "TransportAmount", thClass: "text-nowrap", tdClass: "w-4 text-nowrap text-right" },
                { name: "Vade [Gün]", key: "Vade", thClass: "text-nowrap", tdClass: "w-4 text-nowrap text-center" },
                { name: "Tedarikçi", key: "Supplier", thClass: "text-nowrap", tdClass: "w-10 text-nowrap" },
                { name: "Araç Plakası", key: "VehiclePlate", thClass: "text-nowrap", tdClass: "w-7 text-nowrap" },
                { name: "Treyler Plakası", key: "TrailerPlate", thClass: "text-nowrap", tdClass: "w-7 text-nowrap" },
                { name: "Şube", key: "FuelOrderBranch", thClass: "text-nowrap", tdClass: "w-7 text-nowrap" },
                { name: "Sürücü", key: "DriverEmployee", thClass: "text-nowrap", tdClass: "w-9 text-nowrap" },
                { name: "Oluşturulma Tarihi", key: "CreateTimeValue", thClass: "text-nowrap", tdClass: "w-9 text-nowrap" },
            ],
            buttons: [
                {
                    text: "Düzenle",
                    key: "edit",
                    icon: "Edit2Icon",
                    variant: "secondary",
                    action: this.edit,
                    condition: (item) => item.OrderStatus === 0,
                },
                {
                    text: "Görüntüle",
                    key: "view",
                    icon: "EyeIcon",
                    variant: "info",
                    action: this.edit,
                    condition: (item) => item.OrderStatus > 0,
                },
                {
                    text: "Evrakları İncele",
                    key: "review_docs",
                    icon: "ZoomInIcon",
                    variant: "secondary",
                    action: this.reviewDocuments,
                    condition: (item) => item.HasOrderDetail,
                },
                {
                    text: "Evrak İşle",
                    key: "process_docs",
                    icon: "FileTextIcon",
                    variant: "primary",
                    action: this.goToDocumentProcessing,
                    condition: (item) => !item.HasOrderDetail && [2, 3].includes(item.OrderStatus),
                },
                {
                    text: "Sipariş Ver",
                    key: "place",
                    icon: "SendIcon",
                    variant: "success",
                    action: this.placeOrder,
                    condition: (item) => item.OrderStatus === 0,
                },
                {
                    text: "İptal Et",
                    key: "cancel",
                    icon: "XCircleIcon",
                    variant: "danger",
                    action: this.cancelOrder,
                    condition: (item) => ![2, 3, 4].includes(item.OrderStatus),
                },
            ],
            order: {
                Id: null,
                OrderNumber: null,
                // IsAdBlue: false,
                SupplierId: null,
                OrderQuantity: null,
                VehiclePlateId: null,
                TrailerPlateId: null,
                FuelOrderBranchId: null,
                DriverEmployeeId: null,
                DriverEmployee: null,
                // FuelStorageId: null,
                OrderStatus: null,
                OrderDate: null,
                OrderDateValue: null,
                FuelTypeId: null,
                Vade: null,
                UnitPrice: null,
                TransportAmount: null,
                PaymentType: null, // 0: Peşin, 1: KK, 2: Vadeli, 3: DBS
                FuelStorageCreditCardInformationId: null,
                FuelStorageCreditCardLastPaymentDate: null,
                FuelStorageSupplierAgreementId: null,
                FuelStorageSupplierIskontoId: null,
                FuelStorageSupplierIskontoRate: null,
            },
            editing: false,
            loading: false,
            isReadOnly: false,
            isFormInvalid: false,
            selectedOrderId: null,
            fuelTypes: [],
            supplierOptions: [],
            branchOptions: [],
            vehiclePlateOptions: [],
            filter: {
                FuelTypeId: null,
                supplierId: null,
                branchId: null,
                vehiclePlateId: null,
                startDate: null,
                endDate: null,
            },
            excelPayload: null,
            excelPath: null,
            mainOrderModalConfig: {
                visible: false,
                isEdit: false,
                isReadOnly: false,
                data: {
                    MainOrderNumber: "",
                    TotalQuantity: null,
                    ShipmentCount: null,
                    SubOrders: [],
                },
            },
            subOrderEditConfig: {
                visible: false,
                parentIndex: null,
                parentMainOrderNumber: null,
            },
        };
    },
    mounted() {
        this.getFuelTypesForFilter();
        this.getFilterOptions();
    },
    methods: {
        clearFilters() {
            this.filter = {
                fuelTypeId: null,
                supplierId: null,
                branchId: null,
                vehiclePlateId: null,
                startDate: null,
                endDate: null,
            };
            if (this.$refs.table) {
                this.$refs.table.refresh();
            }
        },
        reviewDocuments(item) {
            this.selectedOrderId = item.Id;
            this.$showModal("view-order-detail");
        },
        goToDocumentProcessing(item) {
            this.$router.push({ name: "fuel-order-document-form", params: { id: item.Id } });
        },
        downloadExcel() {
            FuelStorageApi.FuelOrder.GetFuelOrderExcelReport(this.excelPayload)
                .then((res) => {
                    if (res.data.Success) {
                        this.excelPath = res.data.Data;
                        this.$result(res);
                        if (this.excelPath) {
                            Additional.DownloadTab(this.excelPath);
                        }
                    } else {
                        this.$result(res);
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                });
        },
        clearForm() {
            this.order.Id = null;
            this.order.OrderNumber = null;
            //this.order.IsAdBlue = false
            this.order.FuelTypeId = null;
            this.order.SupplierId = null;
            this.order.OrderQuantity = null;
            this.order.VehiclePlateId = null;
            this.order.TrailerPlateId = null;
            this.order.FuelOrderBranchId = null;
            this.order.DriverEmployeeId = null;
            this.order.DriverEmployee = null;
            //this.order.FuelStorageId = null
            this.order.OrderStatus = null;
            this.order.OrderDate = null;
            this.order.OrderDateValue = null;

            // Fiyat ve Vade Alanları Temizliği
            this.order.Vade = null;
            this.order.UnitPrice = null;
            this.order.TransportAmount = null;
            this.order.PaymentType = null;
            this.order.FuelStorageCreditCardInformationId = null;
            this.order.FuelStorageCreditCardLastPaymentDate = null;
            this.order.FuelStorageSupplierAgreementId = null;
            this.order.FuelStorageSupplierIskontoId = null;
            this.order.FuelStorageSupplierIskontoRate = null;
        },
        createNew() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const seconds = String(now.getSeconds()).padStart(2, "0");
            const ms = String(now.getMilliseconds()).padStart(3, "0");
            const mainOrderNumber = `S-${year}${month}${day}${hours}${minutes}${seconds}${ms}`;

            this.mainOrderModalConfig = {
                visible: true,
                isEdit: false,
                isReadOnly: false,
                data: {
                    MainOrderNumber: mainOrderNumber,
                    TotalQuantity: null,
                    ShipmentCount: null,
                    SubOrders: [],
                    FuelTypeId: null,
                    FuelTypeName: null,
                    OrderDate: null,
                    SupplierId: null,
                    PaymentType: null,
                    FuelStorageCreditCardInformationId: null,
                    FuelStorageCreditCardLastPaymentDate: null,
                    Vade: null,
                    UnitPrice: null,
                    FuelStorageSupplierAgreementId: null,
                    FuelStorageSupplierIskontoId: null,
                    FuelStorageSupplierIskontoRate: null,
                },
            };
            this.$showModal("main-order-modal");
        },
        edit(item) {
            this.clearForm();
            this.editing = true;
            this.isReadOnly = item.OrderStatus !== 0;
            this.order.Id = item.Id;
            this.order.OrderNumber = item.OrderNumber;
            //this.order.IsAdBlue = item.IsAdBlue
            this.order.SupplierId = item.SupplierId;
            this.order.OrderQuantity = item.OrderQuantity;
            this.order.FuelTypeId = item.FuelTypeId;
            this.order.VehiclePlateId = item.VehiclePlateId;
            this.order.TrailerPlateId = item.TrailerPlateId;
            this.order.FuelOrderBranchId = item.FuelOrderBranchId;
            this.order.DriverEmployeeId = item.DriverEmployeeId;
            this.order.DriverEmployee = item.DriverEmployee;
            //this.order.FuelStorageId = item.FuelStorageId
            this.order.OrderStatus = item.OrderStatus;
            this.order.OrderDate = item.OrderDate;
            this.order.OrderDateValue = item.OrderDateValue;
            this.order.OrderStatusName = item.OrderStatusName;

            this.order.Vade = item.Vade;
            this.order.UnitPrice = item.UnitPrice;
            this.order.TransportAmount = item.TransportAmount;

            this.order.PaymentType = item.PaymentType;
            this.order.FuelStorageCreditCardInformationId = item.FuelStorageCreditCardInformationId;
            this.order.FuelStorageCreditCardLastPaymentDate = item.FuelStorageCreditCardLastPaymentDate;
            this.order.FuelStorageSupplierAgreementId = item.FuelStorageSupplierAgreementId;
            this.order.FuelStorageSupplierIskontoId = item.FuelStorageSupplierIskontoId;
            this.order.FuelStorageSupplierIskontoRate = item.FuelStorageSupplierIskontoRate;

            this.$showModal("create-or-update");
        },
        getFilterOptions() {
            CompanyApi.Branch.ListByCode("O").then((res) => {
                this.branchOptions = res.data.Data;
            });
            FirmOperationsApi.ListByFirmRole("5").then((res) => {
                this.supplierOptions = res.data.Data;
            });
            VehicleOperationsApi.Plate.ListAll().then((response) => {
                this.vehiclePlateOptions = response.data.Data || [];
            });
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        getFuelTypesForFilter() {
            SystemDataApi.FuelType(true).then((res) => {
                this.fuelTypes = res.data.Data;
            });
        },
        provider(data) {
            const payload = {
                FuelTypeId: this.filter.fuelTypeId,
                SupplierId: this.filter.supplierId,
                FuelOrderBranchId: this.filter.branchId,
                VehiclePlateId: this.filter.vehiclePlateId,
                StartDate: this.filter.startDate,
                EndDate: this.filter.endDate,
                PaginationRequestModel: data,
            };

            this.excelPayload = payload;

            return FuelStorageApi.FuelOrder.Datatable(payload);
        },
        createOrUpdate() {
            if (this.order._isSubOrder) {
                this.loading = false;

                this.handleSubOrderCompleted({
                    index: this.order._subOrderIndex,
                    data: { ...this.order, _isDirty: true },
                });

                this.$hideModal("create-or-update");
                this.$hideModal("create-or-update-new");
                this.clearForm();
                return;
            }

            this.loading = true;
            const request = this.editing ? FuelStorageApi.FuelOrder.Update(this.order) : FuelStorageApi.FuelOrder.Create(this.order);

            request
                .then((res) => {
                    this.$result(res);
                    this.loading = false;
                    if (res.data.Success) {
                        this.$hideModal("create-or-update");
                        this.$refs.table.refresh();
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$result(null, err);
                });
        },
        placeOrder(item) {
            this.$confirm(
                "Sipariş vermek istediğinize emin misiniz?",
                `${item.OrderNumber} numaralı siparişin durumu "Sipariş Verildi" olarak güncellenecektir.`,
            ).then((result) => {
                if (result) {
                    FuelStorageApi.FuelOrder.Confirm(item.Id)
                        .then((res) => {
                            this.$result(res);
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                        })
                        .catch((err) => this.$result(null, err));
                }
            });
        },
        cancelOrder(item) {
            this.$confirm(
                "Siparişi iptal etmek istediğinize emin misiniz?",
                `Bu işlem ${item.OrderNumber} numaralı siparişi iptal edecektir ve geri alınamaz.`,
            ).then((result) => {
                if (result) {
                    FuelStorageApi.FuelOrder.Cancel(item.Id)
                        .then((res) => {
                            this.$result(res);
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                        })
                        .catch((err) => this.$result(null, err));
                }
            });
        },
        async openMainOrderEditModal(item, readOnly = false) {
            try {
                const response = await FuelStorageApi.FuelOrder.ListByMainOrderNumber(item.MainOrderNumber);
                const subOrders = response.data.Data || [];

                this.mainOrderModalConfig = {
                    visible: true,
                    isEdit: true,
                    isReadOnly: readOnly,
                    data: {
                        MainOrderNumber: item.MainOrderNumber,
                        TotalQuantity: item.TotalQuantity || subOrders.reduce((sum, s) => sum + (s.OrderQuantity || 0), 0),
                        ShipmentCount: subOrders.length,
                        SubOrders: subOrders.map((sub) => ({
                            ...sub,
                            OrderDate: sub.OrderDate,
                        })),
                    },
                };
                this.$showModal("main-order-modal");
            } catch (error) {
                this.$result(null, error);
            }
        },

        async saveMainOrder(subOrdersList) {
            if (!subOrdersList || subOrdersList.length === 0) return;

            try {
                const response = await FuelStorageApi.FuelOrder.CreateMultiple(subOrdersList);
                this.$result(response);

                if (response.data.Success) {
                    this.$hideModal("main-order-modal");
                    this.mainOrderModalConfig.visible = false;
                    this.$refs.table.refresh();
                }
            } catch (error) {
                this.$result(null, error);
            }
        },

        closeMainOrderModal() {
            this.mainOrderModalConfig.visible = false;
        },

        openSubOrderEdit({ index, subOrder, mainOrderNumber, mainOrderDate, isReadOnly = false }) {
            this.subOrderEditConfig = {
                index: index,
                mainOrderNumber: mainOrderNumber,
                mainOrderDate: mainOrderDate || null,
            };

            this.order = {
                ...this.getEmptyOrder(),
                ...subOrder,
                Id: subOrder.Id || null,
                MainOrderNumber: mainOrderNumber,
                _isSubOrder: true,
                _subOrderIndex: index,
                _mainOrderDate: mainOrderDate || null,
            };

            this.editing = !!this.order.Id;
            this.isReadOnly = isReadOnly;
            this.$showModal("create-or-update-new");
        },

        handleSubOrderCompleted({ index, data }) {
            if (!this.mainOrderModalConfig.data.SubOrders) {
                return;
            }

            const newSubOrders = [...this.mainOrderModalConfig.data.SubOrders];
            newSubOrders[index] = { ...data, _isDirty: true };

            this.mainOrderModalConfig.data = {
                ...this.mainOrderModalConfig.data,
                SubOrders: newSubOrders,
            };
        },
        getEmptyOrder() {
            return {
                Id: null,
                OrderNumber: null,
                MainOrderNumber: null,
                SupplierId: null,
                OrderQuantity: null,
                VehiclePlateId: null,
                TrailerPlateId: null,
                FuelOrderBranchId: null,
                DriverEmployeeId: null,
                OrderStatus: null,
                OrderDate: null,
                OrderDateValue: null,
                FuelTypeId: null,
                Vade: null,
                UnitPrice: null,
                TransportAmount: null,
                PaymentType: null,
                FuelStorageCreditCardInformationId: null,
                FuelStorageCreditCardLastPaymentDate: null,
                FuelStorageSupplierAgreementId: null,
                FuelStorageSupplierIskontoId: null,
                FuelStorageSupplierIskontoRate: null,
            };
        },

        updateSubOrderField({ index, field, value }) {
            if (!this.mainOrderModalConfig.data.SubOrders[index]) return;
            this.$set(this.mainOrderModalConfig.data.SubOrders[index], field, value);
        },
    },
};
</script>
